import { render, staticRenderFns } from "./AttrSelect.vue?vue&type=template&id=7bd1c3bd&"
import script from "./AttrSelect.vue?vue&type=script&lang=js&"
export * from "./AttrSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports